import styles from "./OnSale.module.scss";
import React, {useContext} from "react";
import { Card } from "react-bootstrap";
import { translateService, Translate } from "../../../services/TranslateService";
import { IOnSale } from "../../../interfaces/VehicleSearch";
import { priceFormat, cx} from "../../MakeReservation/util";
import { useDispatch, useSelector } from "react-redux";
import { GlobalStore } from "../../../reduxStore";
import { DataContext } from "../../../contexts/dataContext";
import { buildSimpleItem } from "../../../services/ga4Ecommerce";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss'
import 'swiper/css/effect-fade'

interface IOnSaleProps{
    details: IOnSale;
    selectVehicle: Function;
}

function AdCard ({adDetails}: any) {
    // Notes:
    // Max 3 ads
    // Ad may contain text, img & btn details/just a picture (will take entire card space)
    return (
        <Card className={styles.adCard}
              onClick={() => {if(adDetails.adUrl) {window.location.href = adDetails.adUrl}}}>
            { adDetails.imageHeight === '87' ?
                    <div className={styles.adTopHeight}/> : null }
            <img  style={{objectFit: 'contain' }}
                  width="130" height={adDetails.imageHeight ?? '87px'} className={cx(styles.carImage,styles.r24onSalesImage)}
                 src={adDetails.imageUrl ?? ''} alt={''} loading="lazy"/>
            { adDetails.imageHeight !== '200' ?
                    <>
                        <div className={styles.r24LeftRightMarginAuto}>
                            <div className={cx(styles.text,"font-weight-bolder")}>{adDetails.test1}</div>
                            <div className={styles.text}>{adDetails.text2}</div>
                            <div className={styles.text}>{adDetails.text3}</div>
                        </div>
                        {adDetails.buttonTxt ?
                            <button className='btn mt-1 btn-sm btn-primary btn-ad-cards text-white font-weight-bold ad-card-btns'
                                    style={{backgroundColor: adDetails.buttonColor, borderColor: adDetails.buttonColor,
                                        color: adDetails.buttonTxtColor}}>
                                {adDetails.buttonTxt}
                            </button>
                            : null}
                    </> : null
            }
        </Card> )
}

function SaleCard ({details, selectVehicle}:IOnSaleProps) {
    const dispatch = useDispatch();
    const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
    const dataContext = useContext(DataContext)

    if (!details.vehicleid) return null; // if 'vehicleid' missing, incorrect data received

    return <Card className="p-1">
        <span className={styles.discountPercentage}>
            {details.discountpercentage}%
        </span>
        <img width="130" height="87" className={cx(styles.carImage,styles.r24onSalesImage)} src={"https://vehicles-cdn.24rent.fi/" + details.image} alt={details.modelname.replace('&sup3','³')} loading="lazy"/>
        <div className={styles.r24LeftRightMarginAuto}>
            <div className={cx(styles.text,"font-weight-bolder")}>{details.modelname.replace('&sup3','³')}</div>
            <div className={styles.text}>{details.address}</div>
            <div className={styles.text}><Translate content={'vehicleSearch.price'} />:{priceFormat((dataContext.noVatPrices ? details.priceNoVat : details.price)*details.discountmultiplier/100)} €</div>
        </div>
        <button onClick={()=>{
            dispatch({ type: 'SET_API_MESSAGE', payload: translateService.translate("vehicleSearch.loading") });
            apiService?.vehicle.searchWithParams({...dataContext.searchParameters,carId:details.vehicleid}, !!dataContext.loggedIn)
                .then(r=> {
                    if(r.vehicles[0]?.availabilityData.available) {
                        selectVehicle({...r.vehicles[0], onsale: {...details}});
                    } else {
                      dispatch({type: 'SET_RESPONSE_MODAL',payload: translateService.translate("vehicleSearch1.notAvailable")})
                    }
                }).catch(e => {
                    if (dataContext.appContext !== "production") console.log(e);
                    dispatch({type: 'SET_RESPONSE_MODAL',payload: translateService.translate('vehicleSearch.errorLoadingResults')});
                }).finally(() =>
                    dispatch({type: 'SET_API_MESSAGE', payload: undefined})
                );
            details.extra ? 
                dataContext.sendGa4Event("select_item", {
                    item_list_id: "extra_on_sales_list",
                    item_list_name: "Extra On Sales",
                    selection_surface: "list",
                    items: [buildSimpleItem({ id: details.vehicleid, name: details.modelname.replace('&sup3','³'), priceEuros: (dataContext.noVatPrices ? details.priceNoVat : details.price) * details.discountmultiplier / 100, category: "extra_on_sale", listId: "extra_on_sales_list", listName: "Extra On Sales" })]
                }) :
                dataContext.sendGa4Event("select_item", {
                    item_list_id: "on_sales_list",
                    item_list_name: "On Sales Results",
                    selection_surface: "list",
                    items: [buildSimpleItem({ id: details.vehicleid, name: details.modelname.replace('&sup3','³'), priceEuros: (dataContext.noVatPrices ? details.priceNoVat : details.price) * details.discountmultiplier / 100, category: "on_sale", listId: "on_sales_list", listName: "On Sales Results" })]
                });
            }}
            className='mt-1 btn btn-sm btn-primary btn-ad-cards text-white font-weight-bold'>
            <Translate content={'vehicleSearch.selectCar'} />
        </button>
    </Card>
}

export default function OnSale({sales, selectVehicle, onSalesAd}: any) {
    if (!sales?.length && !onSalesAd) return null; // maybe add same thing for onSalesAd??
    let onSalesSwiperContent: any[] = [];
    if (sales?.length) {
        sales.forEach((sale: IOnSale) => {
            if (!onSalesSwiperContent.includes(sale)) {
                onSalesSwiperContent.push(sale);
            }
        });

        if (onSalesAd && onSalesAd.length && (onSalesAd.length + onSalesSwiperContent.length) > 10) {
            let numToSlice = onSalesSwiperContent.length - (onSalesAd.length + onSalesSwiperContent.length - 10);
            onSalesSwiperContent = onSalesSwiperContent.slice(0, numToSlice); // only use first 10 sales if more than 10 present
        }
    }

    if (onSalesAd && onSalesAd.length) {
        onSalesAd.sort((a: any, b: any) => {
            // arrange the ads in order of location to allow each ad to be correctly placed without displacement when slicing
            const locA = parseInt(a.location, 10);
            const locB = parseInt(b.location, 10);
            return locA - locB;
        });

        onSalesAd.forEach((ad: any) => {
            const locationIndex = ad.location ? ad.location - 1 : onSalesSwiperContent.length;
            // Ensure the location matches index + 1
            if (locationIndex >= 0) {
                onSalesSwiperContent.splice(locationIndex, 0, ad); // Insert ad and shift existing data forward
            }
        });
    }

    // Remove undefined gaps caused by sparse array indexing
    onSalesSwiperContent = onSalesSwiperContent.filter(Boolean);

    if (onSalesSwiperContent.length > 10) {
        // if somehow more than 10 indexes are present, slice the array to only show 10
        onSalesSwiperContent = onSalesSwiperContent.slice(0, 10);
    }

    return (
        <>
            <Card className={styles['onSaleCard']}>
                <Translate component='h3' className={styles['onSalesHeading']} content={'vehicleSearch.onSalesBannerText'} />
                <div className={styles['swiperDiv']}>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={4}  // Adjust this value to control the number of slides displayed
                        pagination={false}
                        scrollbar={{ draggable: true }}
                        onSwiper={() => {}}
                        navigation={onSalesSwiperContent.length > 1}
                        breakpoints={{
                            100: {slidesPerView: 1, spaceBetween: 5},
                            320: {slidesPerView: 2, spaceBetween: 5},
                            450: {slidesPerView: 3, spaceBetween: 5},
                            640: {slidesPerView: 4, spaceBetween: 5},
                            768: {slidesPerView: 5, spaceBetween: 5}}}>
                        {onSalesSwiperContent.map((details: IOnSale, index: number) => (
                            <SwiperSlide key={index} className={styles['adSwiperEl']}>
                                { details.location ? // ad data
                                    <AdCard adDetails={details} /> :
                                    // if location value not present --> normal clickable onSales vehicle
                                    <SaleCard details={details} selectVehicle={selectVehicle} /> }
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
              <Translate content={'vehicleSearch.onSalesDisclaimer'} className={`${styles['onSalesDescription']} smallCaptions`}/>
            </Card>
        </>
    );
}
